"use client";

import React, { useEffect } from "react";
import { useJoinCommunity } from "../../lib/services/organisation-service";
import DownloadApp from "./DownloadApp";
import ImageComponent from "./ImageComponent";
import { useFormatCurrency } from "./format-currency";
import TicketConfirmation from "../event/TicketConfirmation";
import styles from "./thank-you.module.scss";

const ThankYou = ({ host, loggedInUser, data, isMember }) => {
  const ticket = data?.ticket;
  const { formatCurrency } = useFormatCurrency();
  const { isLoading: isLoadingJoinCommunity, mutate: mutateJoinCommunity } =
    useJoinCommunity({
      onError: () => {},
      onSuccess: async (response) => {},
    });

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (window.scrollY > 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, []);

  const renderHostAvatar = () => {
    if (host && host.image) {
      return (
        <ImageComponent
          src={host.image}
          alt="Host Avatar"
          className={styles.hostAvatar}
        />
      );
    }
    if (host && host.name) {
      const initials = host.name
        .split(" ")
        .map((name) => name[0])
        .join("");
      return (
        <div className={`${styles.hostAvatar} ${styles.hostAvatarPlaceholder}`}>
          {initials}
        </div>
      );
    }
    return null;
  };

  const handleJoinCommunity = () => {
    if (loggedInUser && loggedInUser.user) {
      mutateJoinCommunity({
        orgId: host.profileId,
        userId: loggedInUser.user.userId,
      });
    }
  };

  const formatDateTime = (date, time, timezone) => {
    if (!date) return "N/A";

    const formattedDate = new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: timezone,
    });

    return time ? `${formattedDate}, ${time}` : formattedDate;
  };

  const formatAmount = (amount, currency) => {
    if (!amount) return "Free";
    return formatCurrency(amount, currency || ticket?.currency || "USD");
  };

  return (
    <>
      <div className={styles.thankYouMessage}>
        <h1>Thank You for Your Purchase!</h1>
        <p>
          Your order was successful. You will receive a confirmation email or
          sms shortly. If you have any questions, please contact our support
          team.
        </p>
        <TicketConfirmation
          ticket={ticket}
          event={data?.event}
          formatDateTime={formatDateTime}
          formatAmount={formatAmount}
        />
        {host && host.profileType === "ORGANISATION" && (
          <div className={styles.thankYouJoin}>
            <div className={styles.thankYouJoinDiv}>
              {loggedInUser && loggedInUser.user ? (
                <>
                  <div className={styles.hostInfo}>
                    <h2>Join {host.name} Community on CirclePlug</h2>
                    {renderHostAvatar()}
                    <p>{host.name}</p>
                    {!isMember ? (
                      <button
                        className={styles.joinCommunityButton}
                        onClick={handleJoinCommunity}
                        disabled={isLoadingJoinCommunity}
                      >
                        {isLoadingJoinCommunity
                          ? "Joining Community..."
                          : "Join Community"}
                      </button>
                    ) : (
                      <div className={styles.joinSuccessMessage}>
                        <p>
                          You are already a member of {host.name} community!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <p>
                    Your Order has been set to your email{" "}
                    <b>{data.user.email}</b>. Thanks for purchasing
                  </p>
                </>
              )}
              {/* Always show download button */}
              <div className={styles.downloadButtons}>
                <div className={styles.getit}>
                  <div className={styles.getiton}>
                    Download the Circleplug App to stay connected with{" "}
                    {host.name}
                  </div>
                  <DownloadApp />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ThankYou;
